import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

import { axios } from 'lib';

const createCompanyProfile = ({
  companyID,
  slug,
  website,
}) =>
  axios.post(
    `/api/companies/${companyID}/profile`,
    JSON.stringify({
      slug: slug,
      website: website,
    })
  );

export const useCreateCompanyProfile = (refetch) => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: createCompanyProfile,
    onSuccess: () => {
      enqueueSnackbar('Company profile was successfully updated', {
        variant: 'success',
      });

      refetch();
    },
    onError: (error) => {
      enqueueSnackbar(error?.message || 'Some error occured', { variant: 'error' });
    },
  });
};
